import { render } from "./bundle-item-card.template.html?vue&type=template&id=8e48f340&scoped=true"
import script from "./BundleItemCard.vue?vue&type=script&lang=ts"
export * from "./BundleItemCard.vue?vue&type=script&lang=ts"

import "./BundleItemCard.vue?vue&type=style&index=0&id=8e48f340&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-8e48f340"

export default script